import { render, staticRenderFns } from "./MedicalJournal.vue?vue&type=template&id=7062d58f&"
import script from "./MedicalJournal.vue?vue&type=script&lang=js&"
export * from "./MedicalJournal.vue?vue&type=script&lang=js&"
import style0 from "./MedicalJournal.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports